import styles from './EuroFlag.module.scss';

export const EuroFlag = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <title>Flag_of_Europe</title>
      <g data-name="Layer 2" id="Layer_2">
        <rect className={styles.flagBg} height="32" width="32" />
      </g>
      <g data-name="Layer 1" id="Layer_1">
        <g id="s">
          <g id="c">
            <path className={styles.stars} d="M16,7.11l-.4,1.23.61.2Z" />
            <path className={styles.stars} d="M16,7.11l.4,1.23-.61.2Z" />
          </g>
          <g id="a">
            <path className={styles.stars} d="M17.22,8H15.94v.65Z" />
            <path className={styles.stars} d="M17.22,8l-1,.76-.38-.52Z" />
            <path className={styles.stars} d="M16.76,9.44l-.4-1.22-.61.2Z" />
            <path className={styles.stars} d="M16.76,9.44l-1-.75.37-.52Z" />
          </g>
          <path className={styles.stars} d="M14.78,8h1.28v.65Z" />
          <path className={styles.stars} d="M14.78,8l1,.76.38-.52Z" />
          <path className={styles.stars} d="M15.24,9.44l.4-1.22.61.2Z" />
          <path className={styles.stars} d="M15.24,9.44l1-.75-.37-.52Z" />
        </g>
        <path className={styles.stars} d="M16,22.56l-.4,1.22.61.2Z" />
        <path className={styles.stars} d="M16,22.56l.4,1.22-.61.2Z" />
        <path className={styles.stars} d="M17.22,23.45H15.94v.64Z" />
        <path className={styles.stars} d="M17.22,23.45l-1,.75-.38-.52Z" />
        <path className={styles.stars} d="M16.76,24.89l-.4-1.23-.61.2Z" />
        <path className={styles.stars} d="M16.76,24.89l-1-.76.37-.52Z" />
        <path className={styles.stars} d="M14.78,23.45h1.28v.64Z" />
        <path className={styles.stars} d="M14.78,23.45l1,.75.38-.52Z" />
        <path className={styles.stars} d="M15.24,24.89l.4-1.23.61.2Z" />
        <path className={styles.stars} d="M15.24,24.89l1-.76-.37-.52Z" />
        <g id="l">
          <path className={styles.stars} d="M8.28,14.84l-.4,1.22.61.2Z" />
          <path className={styles.stars} d="M8.28,14.84l.4,1.22-.62.2Z" />
          <path className={styles.stars} d="M9.5,15.73H8.22v.64Z" />
          <path className={styles.stars} d="M9.5,15.73l-1,.75L8.08,16Z" />
          <path className={styles.stars} d="M9,17.16l-.39-1.22-.61.2Z" />
          <path className={styles.stars} d="M9,17.16l-1-.75.38-.52Z" />
          <path className={styles.stars} d="M7.05,15.73H8.34v.64Z" />
          <path className={styles.stars} d="M7.05,15.73l1,.75L8.47,16Z" />
          <path className={styles.stars} d="M7.52,17.16l.4-1.22.61.2Z" />
          <path className={styles.stars} d="M7.52,17.16l1-.75-.37-.52Z" />
          <path className={styles.stars} d="M11.38,10.48l1-.76-.37-.52Z" />
          <path className={styles.stars} d="M11.38,10.48l.4-1.23.61.2Z" />
          <path className={styles.stars} d="M10.92,9l1,.75.37-.52Z" />
          <path className={styles.stars} d="M10.92,9H12.2v.64Z" />
          <path className={styles.stars} d="M12.14,8.15l-.4,1.22.61.2Z" />
          <path className={styles.stars} d="M12.14,8.15l.4,1.22-.62.2Z" />
          <path className={styles.stars} d="M12.9,10.48l-1.05-.76.38-.52Z" />
          <path className={styles.stars} d="M12.9,10.48l-.4-1.23-.61.2Z" />
          <path className={styles.stars} d="M13.36,9l-1,.75-.38-.52Z" />
          <path className={styles.stars} d="M13.36,9H12.08v.64Z" />
          <path className={styles.stars} d="M10.07,13.3l-.4-1.22-.61.2Z" />
          <path className={styles.stars} d="M10.07,13.3l-1-.75L9.41,12Z" />
          <path className={styles.stars} d="M8.56,13.3l1-.75L9.22,12Z" />
          <path className={styles.stars} d="M8.56,13.3,9,12.08l.62.2Z" />
          <path className={styles.stars} d="M8.09,11.86l1,.76.38-.52Z" />
          <path className={styles.stars} d="M8.09,11.86H9.38v.65Z" />
          <path className={styles.stars} d="M10.54,11.86l-1,.76-.38-.52Z" />
          <path className={styles.stars} d="M10.54,11.86H9.25v.65Z" />
          <path className={styles.stars} d="M9.31,11l.4,1.22-.61.2Z" />
          <path className={styles.stars} d="M9.31,11,8.92,12.2l.61.2Z" />
          <path className={styles.stars} d="M10.54,19.59H9.25v.64Z" />
          <path className={styles.stars} d="M10.54,19.59l-1,.75-.38-.52Z" />
          <path className={styles.stars} d="M10.07,21l-.4-1.22-.61.2Z" />
          <path className={styles.stars} d="M10.07,21l-1-.75.38-.52Z" />
          <path className={styles.stars} d="M8.56,21l1-.75-.38-.52Z" />
          <path className={styles.stars} d="M8.56,21,9,19.8l.62.2Z" />
          <path className={styles.stars} d="M9.31,18.7l.4,1.22-.61.2Z" />
          <path className={styles.stars} d="M9.31,18.7l-.39,1.22.61.2Z" />
          <path className={styles.stars} d="M8.09,19.59H9.38v.64Z" />
          <path className={styles.stars} d="M8.09,19.59l1,.75.38-.52Z" />
          <path className={styles.stars} d="M13.36,22.41H12.08v.65Z" />
          <path className={styles.stars} d="M13.36,22.41l-1,.76-.38-.52Z" />
          <path className={styles.stars} d="M12.9,23.85l-.4-1.22-.61.2Z" />
          <path className={styles.stars} d="M12.9,23.85l-1.05-.76.38-.52Z" />
          <path className={styles.stars} d="M11.38,23.85l1-.76-.37-.52Z" />
          <path className={styles.stars} d="M11.38,23.85l.4-1.22.61.2Z" />
          <path className={styles.stars} d="M12.14,21.52l.4,1.23-.62.2Z" />
          <path className={styles.stars} d="M12.14,21.52l-.4,1.23.61.2Z" />
          <path className={styles.stars} d="M10.92,22.41H12.2v.65Z" />
          <path className={styles.stars} d="M10.92,22.41l1,.76.37-.52Z" />
        </g>
        <path className={styles.stars} d="M23.72,14.84l.4,1.22-.61.2Z" />
        <path className={styles.stars} d="M23.72,14.84l-.4,1.22.62.2Z" />
        <path className={styles.stars} d="M22.5,15.73h1.28v.64Z" />
        <path className={styles.stars} d="M22.5,15.73l1,.75.38-.52Z" />
        <path className={styles.stars} d="M23,17.16l.39-1.22.61.2Z" />
        <path className={styles.stars} d="M23,17.16l1-.75-.38-.52Z" />
        <path className={styles.stars} d="M25,15.73H23.66v.64Z" />
        <path className={styles.stars} d="M25,15.73l-1.05.75L23.53,16Z" />
        <path className={styles.stars} d="M24.48,17.16l-.4-1.22-.61.2Z" />
        <path className={styles.stars} d="M24.48,17.16l-1-.75.37-.52Z" />
        <path className={styles.stars} d="M20.62,10.48l-1-.76L20,9.2Z" />
        <path className={styles.stars} d="M20.62,10.48l-.4-1.23-.61.2Z" />
        <path className={styles.stars} d="M21.08,9l-1,.75-.37-.52Z" />
        <path className={styles.stars} d="M21.08,9H19.8v.64Z" />
        <path className={styles.stars} d="M19.86,8.15l.4,1.22-.61.2Z" />
        <path className={styles.stars} d="M19.86,8.15l-.4,1.22.62.2Z" />
        <path className={styles.stars} d="M19.1,10.48l1-.76-.38-.52Z" />
        <path className={styles.stars} d="M19.1,10.48l.4-1.23.61.2Z" />
        <path className={styles.stars} d="M18.64,9l1,.75.38-.52Z" />
        <path className={styles.stars} d="M18.64,9h1.28v.64Z" />
        <path className={styles.stars} d="M21.93,13.3l.4-1.22.61.2Z" />
        <path className={styles.stars} d="M21.93,13.3l1-.75L22.59,12Z" />
        <path className={styles.stars} d="M23.44,13.3l-1-.75.38-.52Z" />
        <path className={styles.stars} d="M23.44,13.3l-.39-1.22-.62.2Z" />
        <path className={styles.stars} d="M23.91,11.86l-1,.76-.38-.52Z" />
        <path className={styles.stars} d="M23.91,11.86H22.62v.65Z" />
        <path className={styles.stars} d="M21.46,11.86l1,.76.38-.52Z" />
        <path className={styles.stars} d="M21.46,11.86h1.29v.65Z" />
        <path className={styles.stars} d="M22.69,11l-.4,1.22.61.2Z" />
        <path className={styles.stars} d="M22.69,11l.39,1.22-.61.2Z" />
        <path className={styles.stars} d="M21.46,19.59h1.29v.64Z" />
        <path className={styles.stars} d="M21.46,19.59l1,.75.38-.52Z" />
        <path className={styles.stars} d="M21.93,21l.4-1.22.61.2Z" />
        <path className={styles.stars} d="M21.93,21l1-.75-.38-.52Z" />
        <path className={styles.stars} d="M23.44,21l-1-.75.38-.52Z" />
        <path className={styles.stars} d="M23.44,21l-.39-1.22-.62.2Z" />
        <path className={styles.stars} d="M22.69,18.7l-.4,1.22.61.2Z" />
        <path className={styles.stars} d="M22.69,18.7l.39,1.22-.61.2Z" />
        <path className={styles.stars} d="M23.91,19.59H22.62v.64Z" />
        <path className={styles.stars} d="M23.91,19.59l-1,.75-.38-.52Z" />
        <path className={styles.stars} d="M18.64,22.41h1.28v.65Z" />
        <path className={styles.stars} d="M18.64,22.41l1,.76.38-.52Z" />
        <path className={styles.stars} d="M19.1,23.85l.4-1.22.61.2Z" />
        <path className={styles.stars} d="M19.1,23.85l1-.76-.38-.52Z" />
        <path className={styles.stars} d="M20.62,23.85l-1-.76.37-.52Z" />
        <path className={styles.stars} d="M20.62,23.85l-.4-1.22-.61.2Z" />
        <path className={styles.stars} d="M19.86,21.52l-.4,1.23.62.2Z" />
        <path className={styles.stars} d="M19.86,21.52l.4,1.23-.61.2Z" />
        <path className={styles.stars} d="M21.08,22.41H19.8v.65Z" />
        <path className={styles.stars} d="M21.08,22.41l-1,.76-.37-.52Z" />
      </g>
    </svg>
  );
};
